export const MAX_CARD_ID = 27;
